export default {
  "redPacketRain.redPacketRainConf": "RedPacketRainConfig",
  "redPacketRain.thead.index": "#No",
  "redPacketRain.thead.id": "Id",
  "redPacketRain.thead.title": "Title",
  "redPacketRain.thead.type": "Type",
  "redPacketRain.thead.scopeType": "ScopeType",
  "redPacketRain.thead.depositNearDays": "DepositNearDays",
  "redPacketRain.thead.userno": "Userno",
  "redPacketRain.thead.probabilityList": "ProbabilityList",
  "redPacketRain.thead.amount": "Amount",
  "redPacketRain.thead.probability": "Probability",
  "redPacketRain.thead.pushTime": "pushTime",
  "redPacketRain.thead.pushTime.start": "Start Time",
  "redPacketRain.thead.pushTime.end": "End Time",
  "redPacketRain.thead.action": "Action",
  "redPacketRain.tooltip.copyUserNo": "CopyUserNo",
  "redPacketRain.tooltip.userDetails": "UserDetails",
};
